function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "instagram_svg__a",
  x1: 2.52,
  y1: 2.52,
  x2: 27.48,
  y2: 27.49,
  gradientTransform: "matrix(1 0 0 -1 0 30)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd600"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff0100"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#d800b9"
})), React.createElement("linearGradient", {
  id: "instagram_svg__b",
  x1: 9.55,
  y1: 9.56,
  x2: 20.45,
  y2: 20.45,
  gradientTransform: "matrix(1 0 0 -1 0 30)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ff6400"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff0100"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fd0056"
})), React.createElement("linearGradient", {
  id: "instagram_svg__c",
  x1: 21.73,
  y1: 21.74,
  x2: 24.28,
  y2: 24.28,
  gradientTransform: "matrix(1 0 0 -1 0 30)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f30072"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#e50097"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.91 8.82a11 11 0 00-.7-3.65 7.17 7.17 0 00-1.73-2.65A7.17 7.17 0 0024.83.79a11 11 0 00-3.65-.7C19.58 0 19.07 0 15 0s-4.58 0-6.18.09a11 11 0 00-3.65.7 7.17 7.17 0 00-2.65 1.73A7.17 7.17 0 00.79 5.17a11 11 0 00-.7 3.65C0 10.42 0 10.93 0 15s0 4.58.09 6.18a11 11 0 00.7 3.65 7.17 7.17 0 001.73 2.65 7.17 7.17 0 002.65 1.73 11 11 0 003.65.7c1.6.07 2.11.09 6.18.09s4.59 0 6.18-.09a11 11 0 003.65-.7 7.68 7.68 0 004.38-4.38 11 11 0 00.7-3.65c.09-1.6.09-2.11.09-6.18s0-4.58-.09-6.18zm-2.7 12.24a8.3 8.3 0 01-.52 2.79 4.94 4.94 0 01-2.84 2.84 8.3 8.3 0 01-2.79.52c-1.58.07-2 .09-6.06.09s-4.48 0-6.06-.09a8.3 8.3 0 01-2.79-.52 4.58 4.58 0 01-1.72-1.12 4.58 4.58 0 01-1.12-1.72 8.3 8.3 0 01-.52-2.79C2.72 19.48 2.7 19 2.7 15s0-4.48.09-6.06a8.3 8.3 0 01.52-2.79 4.58 4.58 0 011.12-1.72 4.58 4.58 0 011.72-1.12 8.3 8.3 0 012.79-.52C10.52 2.72 11 2.7 15 2.7c4 0 4.48 0 6.06.09a8.3 8.3 0 012.79.52 4.58 4.58 0 011.72 1.12 4.58 4.58 0 011.12 1.72 8.3 8.3 0 01.52 2.79c.07 1.58.09 2.05.09 6.06s-.02 4.48-.09 6.06z",
  fill: "url(#instagram_svg__a)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 7.3a7.7 7.7 0 107.7 7.7A7.7 7.7 0 0015 7.3zM15 20a5 5 0 115-5 5 5 0 01-5 5z",
  fill: "url(#instagram_svg__b)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.81 7A1.8 1.8 0 1123 5.19 1.8 1.8 0 0124.81 7z",
  fill: "url(#instagram_svg__c)"
});

function SvgInstagram(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "assets/images/instagram.a8c193b8.svg";
export { SvgInstagram as ReactComponent };